export const isSelectElement = (
  el: HTMLSelectElement | HTMLInputElement,
): el is HTMLSelectElement =>
  el.type === 'select' || el.type === 'select-multiple'
